import anewSignIn from './anewSignIn';
import { readCookie, setDomainCookie } from './cookie';
import getAppClient, { AppClientValue } from './getAppClient';
import Logger from './Logger';

export interface Subject {
  id: string;
  name: string;
}

const SUBJECT_KEY = 'subject';

function loadSubject(): Subject | null {
  const raw = localStorage.getItem(SUBJECT_KEY) ?? readCookie(SUBJECT_KEY);
  if (!raw) return null;
  try {
    const s = JSON.parse(raw) as Subject;
    localStorage.setItem(SUBJECT_KEY, JSON.stringify(s));
    return s;
  } catch (e) {
    Logger.error(e);
    return null;
  }
}

export function hasSubject() {
  return !!loadSubject();
}

export function getSubject(): Subject {
  const s = loadSubject();
  if (s) return s;

  if (getAppClient() !== AppClientValue.Student) {
    anewSignIn('没有选择学科，请重新登录');
  }

  return { id: '', name: '' };
}

export function setSubject(subject: Subject) {
  const val = JSON.stringify(subject);
  localStorage.setItem(SUBJECT_KEY, val);
  setDomainCookie(SUBJECT_KEY, val);
}

export function syncSubjectToCookie() {
  const s = loadSubject();
  if (s) {
    setDomainCookie(SUBJECT_KEY, JSON.stringify(s));
  }
}
